import { Component, Input, OnInit } from '@angular/core'
import { ConfirmDialogService, SaveForm, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { AutopilotAutomationBaseComponent } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automation.component'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import {
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-new-task-automation',
  templateUrl: './new-task-automation.component.html',
  styleUrls: ['./new-task-automation.component.scss'],
})
export class NewTaskAutomationComponent extends AutopilotAutomationBaseComponent implements OnInit {
  @Input() type = AutomationTypes.Task
  @Input() handler = AutomationHandler.TaskCreateHandler
  @Input() hideDateFields = false

  // predefined task data
  _taskData: any
  @Input() set task(task: any) {
    this.form.patchValue({ data: task }, { emitEvent: false })
    this._taskData = task
  }
  get task() {
    return this._taskData
  }

  isDraftTaskCtrl = new FormControl(false)

  constructor(
    private actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected confirm: ConfirmDialogService
  ) {
    super(store, amplitudeService, confirm)
    this.form.addControl('data', new FormControl({}))
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$.pipe(untilDestroy(this)).subscribe((item) => {
      this.form.patchValue(
        {
          data: item?.settings?.task || this.task,
        },
        { emitEvent: false }
      )
      this.isDraftTaskCtrl.setValue(!!item?.settings?.draft)
    })

    this.actions
      .pipe(
        ofType(AutomationWizardSaveAction),
        filter(() => this.viewType !== 'table'),
        untilDestroy(this)
      )
      .subscribe((action) => {
        if (this.automationGroup) {
          this.doSave(this.form, action.closeAfterSave)
        } else if (action.closeAfterSave) {
          this.store.dispatch(AutomationWizardCloseAction())
        }
      })
  }

  tryToCreateOrUpdateAutomation(status: boolean) {
    if (this.automationGroup) {
      this.toggleAutomation(status)
    } else {
      this.doSave(this.form)
    }
  }

  @SaveForm()
  doSave(form: FormGroup, closeAfterSave = false) {
    const autoFormData = this.form.getRawValue()
    autoFormData.draft = this.isDraftTaskCtrl.value ? 1 : 0
    this.saveAutomation(autoFormData)
    if (closeAfterSave) {
      this.store.dispatch(AutomationWizardCloseAction())
    }
  }

  getAutopilotId() {
    return `autopilot-task|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }

  onSaveData(data: any) {
    this.form.get('data').setValue(data, { emitEvent: false })
    this.doSave(this.form)
  }
}
